import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.internal-only-badge': {
    width: theme.space[6],
    height: theme.space[6],
    borderRadius: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    '&--hover:hover': {
      backgroundColor: COLORS.NEUTRAL100,
    },
  },
});
